import FillPassengers from '../fillPassengers/FillPassengers';
import { useBooking } from '../../../../../../contexts/ticketBookingContext/TicketBookingContext';
import ChooseClasses from '../chooseClasses/ChooseClasses';
import PaymentMethod from '../choosePaymentMethod/PaymentMethod';

export default function AutoBookingTabItems() {
  const {
    departurePassengersForm,
    returnPassengersForm,
    departureChosenSeats,
    returnChosenSeats,
    savedPassengers,
    services,
    bookingData,
    departureClassesForm,
    returnClassesForm,
  } = useBooking();

  const isReturnWay = Boolean(bookingData?.return?.id);

  return [
    {
      key: 1,
      children: <ChooseClasses
        bookClassesForm={departureClassesForm}
        direction="departure"
        typeBooking={false}
      />,
    },
    {
      key: isReturnWay ? 2 : 100,
      children: <ChooseClasses
        direction="return"
        typeBooking={false}
        bookClassesForm={returnClassesForm}
      />,
    },
    {
      key: isReturnWay ? 3 : 2,
      children: <FillPassengers
        form={departurePassengersForm}
        departureChosenSeats={departureChosenSeats}
        rideId={bookingData?.departure?.id}
        savedPassengers={savedPassengers}
        services={services}
      />,
    },
    {
      key: isReturnWay ? 4 : 101,
      children: <FillPassengers
        form={returnPassengersForm}
        departureChosenSeats={returnChosenSeats}
        rideId={bookingData?.return?.id}
        savedPassengers={savedPassengers}
        services={services}
      />,
    },
    {
      key: isReturnWay ? 5 : 3,
      children: <PaymentMethod />,
    },
  ];
}
